import {
  getSendrealmClient,
  init,
  type SendrealmInitializeResult
} from '@sendrealm/react';

import env from '../config/env';

let initializationPromise: Promise<SendrealmInitializeResult> | null = null;

export function initializeSendrealmWebPush() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Sendrealm web push requires a browser'));
  }

  if (!initializationPromise) {
    initializationPromise = init({
      appId: env.SENDREALM.APP_ID,
      environment: env.SENDREALM.ENVIRONMENT as 'development' | 'production',
      autoRequestPermission: false,
      serviceWorkerPath: '/sendrealm-service-worker.js',
      serviceWorkerScope: '/'
    }).catch(error => {
      initializationPromise = null;
      throw error;
    });
  }

  return initializationPromise;
}

export async function logoutSendrealmWebPush(): Promise<void> {
  const activeInitialization = initializationPromise;
  if (!activeInitialization) return;

  try {
    await activeInitialization;
    await getSendrealmClient().logout();
  } catch (error) {
    // Authentication cleanup must continue even when push is unavailable.
    console.error('Unable to unlink Sendrealm web push', error);
  }
}
